import { render, staticRenderFns } from "./IconNotifications.vue?vue&type=template&id=a1445600&scoped=true"
import script from "./IconNotifications.vue?vue&type=script&lang=js"
export * from "./IconNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1445600",
  null
  
)

export default component.exports